import React from 'react';
import { Link } from 'react-router-dom';

function MainHomeModel() {
  return (
    <div className=" font-thin">

      {/* Main Image */}
      <div className="w-full">
        <img className="w-full h-[400px] mt-20 sm:h-[500px] md:h-[600px] object-cover" 
             src="images/modelmain2.png" 
             alt="Main Model" />
      </div>

     
<section className="px-6 md:px-32">
        <div className="flex flex-col items-center justify-center text-black p-6">
          <h1 className="text-3xl mb-4 md:text-4xl text-center">Models</h1>
          <p className="text-lg max-w-2xl text-center md:text-2xl text-gray-500">
          Meet our wide range of solutions, find what you are looking for, showcases, multidecks, storage counters…
          </p>
        </div>

        <div className="flex justify-center">
          <Link to="/" className="block py-1 pl-4 hover:underline mt-3">Home -</Link>
          <button className="block py-1 pl-4 hover:underline uppercase mt-3">Typologies</button>
        </div>
      </section>
<h1 className='text-3xl text-center mt-6 text-gray-600 font-thin'>Typologies</h1>
      {/* Models Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 mt-8 xl:px-40 mb-20">
        
        {/* Model Card */}
        {[
          { to: "/display", img: "images/displaycases.jpg", title: "Display Cases & Serve-Overs", desc: "Cold, hot, or dry/ambient for Ice-cream, Chocolates, we offer a complete range ." },
          { to: "/multideck", img: "images/multimodel.jpg", title: "Multidecks", desc: "Available in multiple options for food and beverage preservation in a chilled." },
          { to: "/islands", img: "images/islandsmodel.jpg", title: "Islands", desc: "For promotional actions or to easily move your products to wherever convenient, DSGO." },
          { to: "/semiverticals", img: "images/semimodel.jpg", title: "Semi-Verticals", desc: "Our Semi-Verticals and Grab & Go are available for preservation of drinks and food in a chilled." },
          { to: "/moresolutions", img: "images/moremodel.jpg", title: "More Solutions", desc: "Specialist solutions for specific market needs." },
          { to: "/intelligent", img: "images/intellimodel.jpg", title: "Intelligent Solutions", desc: "Advanced technological solutions for food display and storage using state-of-the-art." }
        ].map((item, index) => (
          <Link key={index} to={item.to} className="group">
            <div className="flex flex-col items-center text-center p-4  transition-all">
              <img className="w-full h-60 sm:h-72 md:h-80 lg:h-96 object-contain" 
                   src={item.img} 
                   alt={item.title} />
              <h1 className="text-2xl sm:text-3xl  text-gray-500 md:mt-4 ">
                {item.title}
              </h1>
              <p className="text-lg text-gray-500 mt-4  max-w-sm">
                {item.desc}
              </p>
            </div>
          </Link>
        ))}

      </div>
    </div>
  );
}

export default MainHomeModel;
